import axios from 'axios';

export default async (entityType, entityId, clientId) => {
  const result = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/hooyu/${entityType}/${entityId}/${clientId}`);
  return result.data;
};
